import { graphql } from "@opensea/graphql"
import { currencyIdentifierFragment } from "../utils"
import { useDefaultSwapCounterpartCurrencyFragment } from "./use-default-swap-counterpart-currency.fragment"

export const CurrencySwapModuleFragment = graphql(
  `
    fragment CurrencySwapModule on Currency {
      contractAddress
      symbol
      isSwapDisabled
      chain {
        identifier
        swapsSupported
      }
      ...currencyIdentifier
      ...useDefaultSwapCounterpartCurrency
    }
  `,
  [currencyIdentifierFragment, useDefaultSwapCounterpartCurrencyFragment],
)
